/**
 * FilterBar Component
 * Horizontal filter controls bar (date, status, search, custom filters)
 * Standardized filter UI used across all list pages
 */

import React from 'react';
import { Row, Col, Space, Button } from 'antd';
import { ClearOutlined } from '@ant-design/icons';
import { spacing } from '../../theme/designTokens';

/**
 * FilterBar Component
 *
 * @param {ReactNode} children - Filter controls (Select, DatePicker, Input, etc.)
 * @param {function} onClear - Clear filters callback
 * @param {boolean} showClearButton - Show clear button (default: true)
 * @param {ReactNode} extra - Additional content (right-aligned)
 * @param {Object} style - Additional styles
 */
function FilterBar({
  children,
  onClear,
  showClearButton = true,
  extra,
  style = {},
}) {
  return (
    <div
      style={{
        padding: `${spacing.md}px ${spacing.lg}px`,
        backgroundColor: '#fafafa',
        borderRadius: '8px',
        marginBottom: spacing.lg,
        ...style,
      }}
    >
      <Row gutter={[16, 16]} align="middle">
        <Col flex="auto">
          <Space wrap size="middle">
            {children}
          </Space>
        </Col>

        {/* Right-aligned actions */}
        {(showClearButton || extra) && (
          <Col>
            <Space>
              {extra}
              {showClearButton && onClear && (
                <Button
                  icon={<ClearOutlined />}
                  onClick={onClear}
                  type="default"
                >
                  Clear Filters
                </Button>
              )}
            </Space>
          </Col>
        )}
      </Row>
    </div>
  );
}

export default FilterBar;
